import isObject from 'lodash/isObject';
import { useEffect, useState } from 'react';
const isBrowser = () => typeof window !== 'undefined';
const parseReadValue = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        console.warn(`Could not parse value read from localStorage.`);
    }
    return value;
};
const readValue = (key) => {
    if (isBrowser()) {
        try {
            return window.localStorage.getItem(key);
        }
        catch (e) {
            console.warn(`Could not read "${key}" from localStorage.`);
        }
    }
    return undefined;
};
const stringifyWriteValue = (value) => {
    try {
        return value && isObject(value) ? JSON.stringify(value) : value;
    }
    catch (e) {
        console.warn(`Could not stringify value before writing it to localStorage.`);
    }
    return value;
};
const writeValue = (key, value) => {
    if (isBrowser()) {
        try {
            window.localStorage.setItem(key, value);
        }
        catch (e) {
            console.warn(`Could not write "${key}" to localStorage.`);
        }
    }
};
export const useLocalStorage = (key, initialValue) => {
    const [value, setValue] = useState(initialValue);
    useEffect(() => {
        const rawValue = readValue(key);
        setValue(rawValue ? parseReadValue(rawValue) : rawValue || initialValue);
    }, [key]);
    const handleSetValue = (value) => {
        const stringifiedValue = stringifyWriteValue(value);
        writeValue(key, stringifiedValue);
        setValue(value);
    };
    return [value, handleSetValue];
};
//# sourceMappingURL=useLocalStorage.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
